"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotoSansFonts = void 0;
const STORAGE_PATH = "https://dcicons.s3.ap-northeast-1.amazonaws.com/new";
// const BLACK_900 = '/fonts/NotoSansKR-Black'
const BOLD_700 = "/fonts/NotoSansKR-Bold";
const MEDIUM_500 = "/fonts/NotoSansKR-Medium";
const REGULAR_400 = "/fonts/NotoSansKR-Regular";
const LIGHT_300 = "/fonts/NotoSansKR-Light";
const THIN_100 = "/fonts/NotoSansKR-Thin";
exports.NotoSansFonts = {
    bold700: {
        woff2: `${STORAGE_PATH}${BOLD_700}.woff2`,
        woff: `${STORAGE_PATH}${BOLD_700}.woff`,
        otf: `${STORAGE_PATH}${BOLD_700}.otf`,
    },
    medium500: {
        woff2: `${STORAGE_PATH}${MEDIUM_500}.woff2`,
        woff: `${STORAGE_PATH}${MEDIUM_500}.woff`,
        otf: `${STORAGE_PATH}${MEDIUM_500}.otf`,
    },
    regular400: {
        woff2: `${STORAGE_PATH}${REGULAR_400}.woff2`,
        woff: `${STORAGE_PATH}${REGULAR_400}.woff`,
        otf: `${STORAGE_PATH}${REGULAR_400}.otf`,
    },
    light300: {
        woff2: `${STORAGE_PATH}${LIGHT_300}.woff2`,
        woff: `${STORAGE_PATH}${LIGHT_300}.woff`,
        otf: `${STORAGE_PATH}${LIGHT_300}.otf`,
    },
    thin100: {
        woff2: `${STORAGE_PATH}${THIN_100}.woff2`,
        woff: `${STORAGE_PATH}${THIN_100}.woff`,
        otf: `${STORAGE_PATH}${THIN_100}.otf`,
    },
};
